import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../authentication.service';
import { Login } from '../../api/models/login';
import { Router } from '@angular/router';

import swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { TextService } from '../../shared/text.service';
import { TranslateService } from '@ngx-translate/core';
import { ApiService, MinmaxService, ProfileService } from '../../api/services';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {
  user: Login = new Login();
  private langname: string;
  public bytes;

  constructor(private auth: AuthenticationService, private api: ApiService, private router: Router,
    private toastr: ToastrService, private text: TextService, private minmaxService: MinmaxService,
    private profileService: ProfileService, private translate: TranslateService) { }

  ngOnInit() {
  }

  onLogin(): void {
    this.auth.login(this.user.username, this.user.password)
      .subscribe(
        data => {
          // console.log(data);
          this.toastr.success('Welcome back', 'Authenticated successfully');
          this.api.getColorDefs().subscribe(
            (resp) => {
              localStorage.setItem('colors', JSON.stringify(resp));
            }
          );
          // const userLogon = JSON.parse(localStorage.getItem('user'));
          // import * as CryptoJS from 'crypto-js';
          this.bytes = CryptoJS.AES.decrypt(localStorage.getItem('user'), 'meg@Moon29');
          const userLogon = JSON.parse(this.bytes.toString(CryptoJS.enc.Utf8));
          if (Number(userLogon.CODE_LANGUE) === 1) {
            this.langname = 'en';
          } else if (Number(userLogon.CODE_LANGUE) === 2) {
            this.langname = 'fr';
          } else if (Number(userLogon.CODE_LANGUE) === 3) {
            this.langname = 'it';
          } else if (Number(userLogon.CODE_LANGUE) === 4) {
            this.langname = 'de';
          } else if (Number(userLogon.CODE_LANGUE) === 5) {
            this.langname = 'es';
          }
          this.translate.use(this.langname);

          this.profileService.getUnits(userLogon.ID_USER).subscribe(
            (res) => {
              // localStorage.setItem('UnitUser', JSON.stringify(res));
              localStorage.setItem('UnitUser', CryptoJS.AES.encrypt(JSON.stringify(res), 'n3wDoe91').toString());
            }
          );

          this.profileService.getMonetaryUser(userLogon.ID_USER).subscribe(
            (res) => {
              localStorage.setItem('MoneratyUser', JSON.stringify(res));
            }
          );
          localStorage.setItem('IdCompInput', null);
          localStorage.setItem('paramsCompInput', null);
          this.router.navigate(['/']);
        },
        error => {
          if (error.status == 422) {
            swal('Warning', 'CO0274: '+this.translate.instant('Username or password required'), 'error');
          }
          if (error.status == 429) {
            swal('Warning', 'CO0276: '+error.error[0], 'error');
          }
          if (error.status == 404) {
            swal('Warning', 'CO0277: '+error.error[0], 'error');
          }
          if (error.status == 405) {
            swal('Warning', 'CO0278: '+error.error[0], 'error');
          }
          if (error.status == 500) {
            swal('Warning', 'CO0279: '+this.translate.instant(error.error[0]), 'error');
          }
          //swal('Warning', 'CO0274:'+error.error[0], 'error');
          // console.log(error.status);
          // console.log(error);
        }
      );
  }

  forgotPassword() {
    swal('Forgot password?', 'CO0275: Please contact our Administrator', 'warning');
  }

}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/authentication/signin/signin.component.ts